"use client";

import { c as _c } from "react/compiler-runtime";
import { Text, HStack, VStack, Link, Card, Spinner, Accordion, Switch, Separator, Collapsible, SystemStyleObject } from "@chakra-ui/react";
import posthog from "posthog-js";
import Pill from "./pill";
import { PillData, LayerIds } from "../data/data";
import { FaCircle, FaSquareFull } from "react-icons/fa";
import { KeyElem } from "./key-elem";
import { Dispatch, SetStateAction, useState } from "react";
import { LayerToggleObjProps } from "./address-mapper";
export interface HazardProps {
  id: number;
  name: string;
  title: string;
  description: string;
  info: string[];
  link: {
    label: string;
    url: string;
  };
  icon: string;
  iconColor: SystemStyleObject["color"];
}
interface CardHazardProps {
  hazard: HazardProps;
  hazardData?: {
    exists?: boolean;
    last_updated?: string;
  };
  showData: boolean;
  isHazardDataLoading: boolean;
  toggledStates: boolean[];
  setToggledStates: Dispatch<SetStateAction<boolean[]>>;
  setLayerToggleObj: Dispatch<SetStateAction<LayerToggleObjProps>>;
}
const MobileCardHazard: React.FC<CardHazardProps> = t0 => {
  const $ = _c(65);
  const {
    hazard,
    hazardData,
    showData,
    isHazardDataLoading,
    toggledStates,
    setToggledStates,
    setLayerToggleObj
  } = t0;
  const {
    id,
    title,
    name,
    description,
    icon,
    iconColor
  } = hazard;
  let t1;
  if ($[0] !== hazardData) {
    t1 = hazardData || {};
    $[0] = hazardData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    exists
  } = t1;
  let t2;
  if ($[2] !== name) {
    t2 = PillData.find(object => object.name === name) ?? {
      trueData: "No Data",
      falseData: "No Data",
      noData: "No Data"
    };
    $[2] = name;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const pillTextOptions = t2;
  const [isMoreInfo, setIsMoreInfo] = useState(false);
  let t3;
  if ($[4] !== exists || $[5] !== isHazardDataLoading || $[6] !== pillTextOptions || $[7] !== showData) {
    t3 = isHazardDataLoading ? <Spinner size="xs" /> : showData ? <Pill exists={exists} trueData={pillTextOptions.trueData} falseData={pillTextOptions.falseData} noData={pillTextOptions.noData} /> : "";
    $[4] = exists;
    $[5] = isHazardDataLoading;
    $[6] = pillTextOptions;
    $[7] = showData;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const hazardPill = t3;
  let t4;
  if ($[9] !== hazard.info) {
    t4 = () => hazard.info.map(_temp);
    $[9] = hazard.info;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const buildHazardCardInfo = t4;
  let t5;
  if ($[11] !== setLayerToggleObj || $[12] !== setToggledStates || $[13] !== toggledStates) {
    t5 = (num, checked) => {
      const newArray = [...toggledStates];
      newArray[num] = checked;
      setToggledStates(newArray);
      setLayerToggleObj({
        layerId: LayerIds[num],
        toggleState: checked
      });
    };
    $[11] = setLayerToggleObj;
    $[12] = setToggledStates;
    $[13] = toggledStates;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const handleSwitchClick = t5;
  const t6 = hazard.name;
  let t7;
  if ($[15] !== icon) {
    t7 = icon === "circle" ? <FaCircle /> : <FaSquareFull />;
    $[15] = icon;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== iconColor || $[18] !== t7 || $[19] !== title) {
    t8 = <KeyElem name={title} color={iconColor} icon={t7} isMobile={true} />;
    $[17] = iconColor;
    $[18] = t7;
    $[19] = title;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== hazardPill || $[22] !== t8) {
    t9 = <Accordion.ItemTrigger p="0" w="full"><Card.Header w="full" p="0" textAlign="left" flexDirection="row" justifyContent="space-between">{t8}{hazardPill}</Card.Header></Accordion.ItemTrigger>;
    $[21] = hazardPill;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = e => setIsMoreInfo(e.open);
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== description) {
    t11 = <Text textStyle="textXSmall" layerStyle="text">{description}</Text>;
    $[25] = description;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  const t12 = toggledStates[id];
  let t13;
  if ($[27] !== handleSwitchClick || $[28] !== id) {
    t13 = e_0 => handleSwitchClick(id, e_0.checked);
    $[27] = handleSwitchClick;
    $[28] = id;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  let t15;
  let t16;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Switch.HiddenInput />;
    t15 = <Switch.Control />;
    t16 = <Switch.Label />;
    $[30] = t14;
    $[31] = t15;
    $[32] = t16;
  } else {
    t14 = $[30];
    t15 = $[31];
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t12 || $[34] !== t13) {
    t17 = <Switch.Root size="lg" colorPalette="blue" checked={t12} onCheckedChange={t13} defaultChecked={true}>{t14}{t15}{t16}</Switch.Root>;
    $[33] = t12;
    $[34] = t13;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t11 || $[37] !== t17) {
    t18 = <Card.Body textAlign="left" p="0"><HStack justifyContent="space-between">{t11}{t17}</HStack></Card.Body>;
    $[36] = t11;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== hazard.name || $[40] !== isMoreInfo) {
    t19 = () => {
      if (!isMoreInfo) {
        posthog.capture("more-info-clicked", {
          hazard_name: hazard.name
        });
      }
    };
    $[39] = hazard.name;
    $[40] = isMoreInfo;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  const t20 = !isMoreInfo ? "More info" : "Less info";
  let t21;
  if ($[42] !== t19 || $[43] !== t20) {
    t21 = <Card.Footer p="0" width="full"><Collapsible.Trigger><Text textStyle="textXSmall" cursor="button" textDecoration="underline" fontWeight="bold" onClick={t19}>{t20}</Text></Collapsible.Trigger></Card.Footer>;
    $[42] = t19;
    $[43] = t20;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Separator mt="2" />;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== buildHazardCardInfo) {
    t23 = buildHazardCardInfo();
    $[46] = buildHazardCardInfo;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== hazard.link.label) {
    t24 = () => posthog.capture("dataset-link-clicked", {
      link_name: hazard.link.label
    });
    $[48] = hazard.link.label;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== hazard.link.label || $[51] !== hazard.link.url || $[52] !== t24) {
    t25 = <Link display="inline-block" href={hazard.link.url} mt="4" target="_blank" textDecoration="underline" onClick={t24} textStyle="textXSmall" fontWeight="bold">{hazard.link.label}</Link>;
    $[50] = hazard.link.label;
    $[51] = hazard.link.url;
    $[52] = t24;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== t23 || $[55] !== t25) {
    t26 = <Collapsible.Content>{t22}{t23}{t25}</Collapsible.Content>;
    $[54] = t23;
    $[55] = t25;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  let t27;
  if ($[57] !== t18 || $[58] !== t21 || $[59] !== t26) {
    t27 = <Accordion.ItemContent maxHeight="unset"><Accordion.ItemBody pb="0"><Collapsible.Root onOpenChange={t10}>{t18}{t21}{t26}</Collapsible.Root></Accordion.ItemBody></Accordion.ItemContent>;
    $[57] = t18;
    $[58] = t21;
    $[59] = t26;
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  let t28;
  if ($[61] !== hazard.name || $[62] !== t27 || $[63] !== t9) {
    t28 = <Card.Root flex={1} w="mobileCardWidth" py="2" px="3" variant="elevated" borderRadius="none"><Accordion.Item border="none" w="mobileCardAccordionWidth" value={t6}>{t9}{t27}</Accordion.Item></Card.Root>;
    $[61] = hazard.name;
    $[62] = t27;
    $[63] = t9;
    $[64] = t28;
  } else {
    t28 = $[64];
  }
  return t28;
};
export default MobileCardHazard;
function _temp(infoItem, index) {
  return <Text as="p" mt="1.5" key={index} textStyle="textXSmall">{infoItem}</Text>;
}